export enum CheckoutType {
    UNKNOWN,
    NORMAL,
    WIDGET,
    APP,
    SUBSCRIPTIONPAYMENT
}